import React, { useRef } from 'react'; // Import useRef
import './style/App.scss';
import './style/fonts.scss'; // Ensure fonts.scss is imported for font definitions

// Importing components
import img_mouse_down from './assets/icons/mouse-down.svg';
import Header from './components/Header.tsx';
import Footer from './components/Footer.tsx';
import Card from './components/Card.tsx'; 
import Form from './components/Form.tsx'; 

// Image imports for the card components
import cardImage1 from './assets/images/card1.webp';
import cardImage2 from './assets/images/no-image.webp';
import cardImage3 from './assets/images/no-image.webp';
import cardImage4 from './assets/images/card4.webp';

// Define the data for the cards
const cards = [
  {
    title: 'Горностай — Ветеринарная клиника',
    desc: 'Брендинг, веб-дизайн & веб-разработка',
    imageUrl: cardImage1,
  },
  {
    title: 'Проект — В разработке',
    desc: 'Временно недоступен',
    imageUrl: cardImage2,
  },
  {
    title: 'Проект — В разработке',
    desc: 'Временно недоступен',
    imageUrl: cardImage3,
  },
  {
    title: 'Место для Вас',
    desc: 'И вашего крутого сайта',
    imageUrl: cardImage4,
  },
];

function App() {
  // Create a ref for the Form component
  const formRef = useRef<HTMLDivElement>(null);

  // Function to scroll to the form section
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App">
      <div className="grid">
        {/*
          ОЧЕНЬ ВАЖНО: Здесь мы передаем функцию scrollToForm
          как свойство onContactClick компоненту Header.
          Без этого Header не будет знать, что такое onContactClick.
        */}
        <Header onContactClick={scrollToForm} />
        <div className='hero-full-screen'>
          <div className='empty'></div>
          <div className='h1-container'>
            <div className='h1-hero'>Воплощаем смелые идеи</div>
            <div className='h1-hero-curved'>cоздаем ваш успех</div>
          </div>
          <div className='mouse-down-container'>
            <div className='body-m-medium'>Scroll down</div>
            <img src={img_mouse_down} alt="Листать вниз" className="img_mouse_down"/>
          </div>
        </div>
        <div className="content">
          <h2>Портфолио</h2>
          <div className='chip-container'>
            <button className='chip-selected body-m'>Все проекты</button>
            <button className='chip-disabled body-m'>Лендинги</button>
            <button className='chip-disabled body-m'>E-commerce</button>
            <button className='chip-disabled body-m'>Корпоративные</button>
          </div>
          {/* Mapping through the cards array and rendering the Card component for each */}
          {cards.map((card, index) => (
            <Card 
              key={index} // Using index as key, consider a unique ID for production if available
              title={card.title} 
              desc={card.desc} 
              imageUrl={card.imageUrl} 
            />
          ))}
        </div>
        {/* Attach the ref to the Form component, wrapped in a div for scrolling */}
        {/* Ref должен быть на элементе, который вы хотите прокрутить к нему */}
        <div ref={formRef}> 
          <Form />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
